import { Unionize } from 'utilitys/helpers/TsGeneral';
import { StateCreator, create } from 'zustand';
import { persist } from 'zustand/middleware';

interface Props {
    isShowCriticalityAnnotation: boolean;
    isShowActivitiesAnnotation: boolean;
    update: (value: Unionize<Omit<Props, 'update'>>) => void;
}
const state: StateCreator<Props> = (set) => ({
    isShowCriticalityAnnotation: false,
    isShowActivitiesAnnotation: false,
    update: (value) => set({ ...value }),
});

export const useGraphAnnotationStore = create(persist(state, { name: 'S-CurveAnnotationStore' }));
